import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BaseService {
  previousButtonClicked$: Subject<boolean> = new Subject<boolean>();
  nextButtonClicked$: Subject<boolean> = new Subject<boolean>();

  triggerManualPrevNavigation$ = new Subject<boolean>();

  subNavigationEnded$: Subject<boolean> = new Subject<boolean>();
  constructor() {}

  getChildren(tab) {
    const newTab = tab.children?.map((child, index) => ({
      index,
      label: child.header,
      component: child.component,
      children: child.children ? this.getChildren(child.children) : undefined,
    }));

    if (tab instanceof Array) {
      return tab.map((t) => ({
        label: t.header,
        component: t.component,
        children: this.getChildren(t),
      }));
    }
    return newTab;
  }
}
